import {gql, useQuery} from '@apollo/client';
import type {QueryHookOptions} from '@apollo/client';
import type {MyDevicesQuery, MyDevicesQueryVariables} from '../types/graphql';

/**
 * Fetch devices for a staff user.
 */
export const MY_DEVICES = gql`
  query MyDevices($id: ID!) {
    node(id: $id) {
      ... on StaffAccount {
        devices {
          id
          address
          type
        }
      }
    }
  }
`;

/**
 * Hook to fetch a user's devices.
 */
export const useMyDevices = (
  opts?: QueryHookOptions<MyDevicesQuery, MyDevicesQueryVariables>,
) => useQuery<MyDevicesQuery, MyDevicesQueryVariables>(MY_DEVICES, opts);
